import { Card, Col, Row, Skeleton } from 'antd';
import { useTranslation } from 'react-i18next';

import { OperationRequestKpis } from 'models/OperationRequest';

import './OpsKpiCards.scss';

interface OpsKpiCardsProps {
  kpis: OperationRequestKpis;
  loading?: boolean;
}

function OpsKpiCards({ kpis, loading }: OpsKpiCardsProps) {
  const { t } = useTranslation();
  const i18nBase = 'scenes.requirements_operation.scene.kpis';

  const avance =
    kpis.slots > 0 ? Math.round((kpis.filled / kpis.slots) * 100) : 0;

  const cards = [
    {
      key: 'open',
      label: t(`${i18nBase}.open.label`),
      value: String(kpis.solicitudes),
      sub: t(`${i18nBase}.open.sub`),
      tone: 'plain' as const,
    },
    {
      key: 'slots',
      label: t(`${i18nBase}.slots.label`),
      value: String(kpis.slots),
      sub: t(`${i18nBase}.slots.sub`, { filled: kpis.filled }),
      tone: 'plain' as const,
    },
    {
      key: 'progress',
      label: t(`${i18nBase}.progress.label`),
      value: `${avance}%`,
      sub: t(`${i18nBase}.progress.sub`),
      tone: 'teal' as const,
    },
    {
      key: 'urgent',
      label: t(`${i18nBase}.urgent.label`),
      value: String(kpis.urgentes),
      sub: t(`${i18nBase}.urgent.sub`),
      tone: (kpis.urgentes > 0 ? 'warn' : 'plain') as 'warn' | 'plain',
    },
  ];

  return (
    <Row gutter={[12, 12]} className="ops-kpi-cards">
      {cards.map((card) => (
        <Col key={card.key} xs={24} sm={12} lg={6}>
          <Card
            bordered
            className={`ops-kpi-cards__card ops-kpi-cards__card--${card.tone}`}
          >
            {loading ? (
              <Skeleton
                active
                paragraph={{ rows: 1 }}
                title={{ width: '60%' }}
              />
            ) : (
              <>
                <div className="ops-kpi-cards__label">{card.label}</div>
                <div className="ops-kpi-cards__value">{card.value}</div>
                <div className="ops-kpi-cards__sub">{card.sub}</div>
              </>
            )}
          </Card>
        </Col>
      ))}
    </Row>
  );
}

export default OpsKpiCards;
